export default {"src":"/_next/static/media/roi-driven-efficiency.f4b71fb1.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};